import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableComponent} from '@blocks/table/table.component';
import {TableInteractionComponent} from '@blocks/table/table-interaction/table-interaction.component';
import {TableMovableDirective} from '@blocks/table/table-directives/table-movable.directive';
import {TableCellSelectableDirective} from '@blocks/table/table-directives/table-cell-selectable.directive';
import {TableAddDeleteDirective} from '@blocks/table/table-directives/table-add-delete.directive';
import {TableResizeColumnsDirective} from '@blocks/table/table-directives/table-resize-columns.directive';
import {TableCopyPasteDirective} from '@blocks/table/table-directives/table-copy-paste.directive';
import {TableSettingsComponent} from '@blocks/table/table-settings/table-settings.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DragHandleModule} from '@shared/controls/drag-handle/drag-handle.module';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';
import {RichTextModule} from '@blocks/rich-text/rich-text.module';
import {FieldsetModule} from '@shared/controls/fieldset/fieldset.module';
import {SwitchModule} from '@shared/controls/switch/switch.module';
import {RangeModule} from '@shared/controls/range/range.module';
import {ColorInputModule} from '@shared/controls/color-input/color-input.module';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@ngneat/transloco';
import {RadioButtonsModule} from '@shared/controls/radio-buttons/radio-buttons.module';
import {PixelModule} from '@shared/controls/pixel/pixel.module';

@NgModule({
  declarations: [
    TableComponent,
    TableInteractionComponent,
    TableMovableDirective,
    TableCellSelectableDirective,
    TableAddDeleteDirective,
    TableResizeColumnsDirective,
    TableCopyPasteDirective,
    TableSettingsComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    DragHandleModule,
    DropdownModule,
    RichTextModule,
    FieldsetModule,
    SwitchModule,
    RangeModule,
    ColorInputModule,
    FormsModule,
    TranslocoModule,
    RadioButtonsModule,
    PixelModule
  ],
  exports: [
    TableComponent,
    TableSettingsComponent
  ]
})
export class TableModule { }
